import React from 'react';
import cx from 'classnames';
import { filterDataProps } from '@THC/utils/helpers';
import { Button } from '../Button';
import { CrossIcon } from '../Icons';
import { IconText } from '../IconText';
import { resolveFontVariant, resolveInfoBoxIcon } from './InfoBox.helpers';
import styles from './InfoBox.module.scss';
export const InfoBox = (props) => {
    const { __internal, content, heading, onClose, size = 'regular', variant = 'default', ...rest } = props;
    const { withAriaRole = true } = __internal || {};
    const icon = resolveInfoBoxIcon(props);
    const fontVariant = resolveFontVariant(heading, size);
    const dataProps = filterDataProps(rest);
    const focusDataProp = dataProps['data-thc-force-state'] === 'focus';
    const explicitRoleProps = withAriaRole ? { 'aria-atomic': true, role: 'status' } : {};
    return (<div className={cx(styles.infoBox, styles[size], styles[variant])} {...(!focusDataProp && { ...dataProps })} {...explicitRoleProps}>
			<div className={styles.iconTextContainer}>
				<IconText icon={icon} text={heading || content} variant={fontVariant}/>
			</div>
			{onClose && (<div className={styles.close}>
					<Button icon={CrossIcon} label="Close information" onClick={onClose} showLabel={false} size="small" variant="tertiary" {...(focusDataProp && { ...dataProps })}/>
				</div>)}
			{heading && content && <div className={styles.contentText}>{content}</div>}
		</div>);
};
